import React from 'react';
import { FaFilePdf, FaVideo, FaTimes } from 'react-icons/fa'; // Using FontAwesome icons

const FileViewer = ({ fileUrls, setAllUploadedFiles }) => {
  // Function to determine the type of file and return appropriate JSX element
  const renderFile = (fileUrl, index) => {
    const fileExtension = fileUrl.split('.').pop().toLowerCase();

    if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
      // For image files
      return (
        <div style={styles.fileContainer} key={index}>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer">
            <img src={fileUrl} alt={`Image ${index + 1}`} style={styles.image} />
          </a>
          <FaTimes
            size={20}
            style={styles.closeButton}
            onClick={() => handleRemoveFile(fileUrl)}
          />
        </div>
      );
    } else if (['mp4', 'webm', 'ogg'].includes(fileExtension)) {
      // For video files
      return (
        <div style={styles.fileContainer} key={index}>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={styles.fileItem}>
            <FaVideo size={30} style={{ marginRight: '10px' }} />
            <span>Video {index + 1}</span>
          </a>
          <FaTimes
            size={20}
            style={styles.closeButton}
            onClick={() => handleRemoveFile(fileUrl)}
          />
        </div>
      );
    } else if (['pdf'].includes(fileExtension)) {
      // For PDF files
      return (
        <div style={styles.fileContainer} key={index}>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer" style={styles.fileItem}>
            <FaFilePdf size={30} style={{ marginRight: '10px' }} />
            <span>PDF {index + 1}</span>
          </a>
          <FaTimes
            size={20}
            style={styles.closeButton}
            onClick={() => handleRemoveFile(fileUrl)}
          />
        </div>
      );
    } else {
      return <p>Unsupported file format: {fileUrl}</p>;
    }
  };

  const handleRemoveFile = (fileUrl) => {
    setAllUploadedFiles((prevFiles) => prevFiles.filter((url) => url !== fileUrl));
  };

  return (
    <div style={styles.container}>
      {fileUrls?.map((fileUrl, index) => renderFile(fileUrl, index))}
    </div>
  );
};

// Styles
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '20px',
  },
  fileContainer: {
    position: 'relative',
    display: 'flex',
    minHeight:"50px",
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10px',
  },
  image: {
    width: '100px',
    height: 'auto',
    borderRadius: '4px',
  },
  fileItem: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#333',
    fontSize: '16px',
  },
  closeButton: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    cursor: 'pointer',
    color: '#ff0000',
  },
};


// Example usage of the component
const ExampleComponent = ({fileData, setAllUploadedFiles}) => {

  const files = fileData;
  return <FileViewer fileUrls={files} setAllUploadedFiles={setAllUploadedFiles}/>;
};

export default ExampleComponent;
